import * as React from 'react';
import { CardsQuestion } from '../../components/CardsQuestion';
import { useHandleSelect } from './utils/useHandleSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export var CardsQuestionContainer = function CardsQuestionContainer(props) {
  var answers = props.answers,
    subType = props.subType;
  var _useHandleSelect = useHandleSelect(props),
    handleSelect = _useHandleSelect.handleSelect,
    value = _useHandleSelect.value;
  if (!answers) {
    return null;
  }
  return /*#__PURE__*/_jsx(CardsQuestion, {
    handleSelect: handleSelect,
    iconType: subType,
    cards: answers,
    value: value
  });
};
CardsQuestionContainer.displayName = 'CardsQuestionContainer';